import { render, staticRenderFns } from "./supplierCard.vue?vue&type=template&id=8b1e081a&scoped=true&"
import script from "./supplierCard.vue?vue&type=script&lang=js&"
export * from "./supplierCard.vue?vue&type=script&lang=js&"
import style0 from "./supplierCard.vue?vue&type=style&index=0&id=8b1e081a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1e081a",
  null
  
)

export default component.exports